"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractStoryboardSpecification = void 0;
var destination_1 = require("./destination");
var ExtractStoryboardSpecification = /** @class */ (function () {
    function ExtractStoryboardSpecification(data) {
        this.destination = new destination_1.Destination(data.destination);
        this.format = data.format;
        this.columns = data.columns;
        this.rows = data.rows;
        this.tileWidth = data.tileWidth;
        this.tileHeight = data.tileHeight;
    }
    return ExtractStoryboardSpecification;
}());
exports.ExtractStoryboardSpecification = ExtractStoryboardSpecification;
//# sourceMappingURL=extract-storyboard-specification.js.map